import type { AnyAction } from 'redux';

import { RootState } from 'store/configureStore';

import * as types from './actionTypes';

type BulkEditEstimatorModalState = {
  isOpen: boolean;
  quoteItemIds: number[];
};

const initialState: BulkEditEstimatorModalState = {
  isOpen: false,
  quoteItemIds: [],
};

export const reducer = (state = initialState, action: AnyAction) => {
  const { payload, type } = action;
  switch (type) {
    case types.OPEN:
      return {
        ...state,
        isOpen: true,
        quoteItemIds: payload.quoteItemIds,
      };
    case types.CLOSE:
      return {
        ...state,
        isOpen: false,
        quoteItemIds: [],
      };
    default:
      return state;
  }
};

const getScope = (state: RootState): BulkEditEstimatorModalState =>
  state.modules.quotes.quoteItemNav.bulkEditEstimatorModal;

export const getIsOpen = (state: RootState) => getScope(state).isOpen;

export const getQuoteItemIds = (state: RootState) =>
  getScope(state).quoteItemIds;
